import React from 'react';
import { useParams } from 'react-router-dom';
import { categoryData } from '../data/categories';
import { useTranslation } from '../../../shared/i18n';
import { 
  BackgroundWrapper, 
  AnimatedTitle, 
  BackButton, 
  CategoryCard, 
  PageContainer,
  PageTransition 
} from '../components';
import sabiduria from '../../../assets/conectados/sabiduria.png';
import alianza from '../../../assets/conectados/alianza.png';
import * as S from './CategoryPage.styles';

// Map category images
const categoryImages = {
  sabiduria,
  alianza
};

// Animation configuration
const subcategoryAnimationConfig = {
  initial: { opacity: 0, y: 30 },
  animate: { 
    opacity: 1, 
    y: 0,
    boxShadow: '0 0 0 rgba(0, 0, 0, 0)'
  },
  whileHover: { 
    scale: 1.1,
    y: -8,
    transition: { duration: 0.3 }
  },
  whileTap: { 
    scale: 1.05,
    y: -4,
    transition: { duration: 0.1 }
  }
};

const getAnimationTransition = (index) => ({
  duration: 0.4, 
  delay: 0.1 + (index * 0.15),
  ease: 'easeOut'
});

function CategoryPage() {
  const { category } = useParams();
  const t = useTranslation();
  const categoryInfo = categoryData[category];

  if (!categoryInfo) {
    return <div>{t('errors.categoryNotFound')}</div>;
  }

  const categoryImage = categoryImages[category];

  return (
    <BackgroundWrapper>
      <PageContainer>
        <AnimatedTitle />
        
        <BackButton to="/conectados">
          {t('conectados.completion.returnToConectados')}
        </BackButton>
        
        <PageTransition>
          <CategoryCard 
            image={categoryImage} 
            alt={t(`conectados.categories.${category}.title`)}
            isStatic
          />
          
          <S.SubcategoriesGrid>
            {categoryInfo.subcategories.map((subcategory, index) => (
              <S.SubcategoryLink 
                key={subcategory.key}
                to={`/conectados/${category}/${subcategory.key}/question`}
              >
                <S.SubcategoryButton
                  {...subcategoryAnimationConfig}
                  transition={getAnimationTransition(index)}
                >
                  {subcategory.image ? (
                    <S.SubcategoryImage 
                      src={subcategory.image} 
                      alt={t(`conectados.subcategories.${subcategory.key}.title`)} 
                    />
                  ) : (
                    <S.SubcategoryPlaceholder background={categoryInfo.color}>
                      <subcategory.titleIcon size={48} />
                      <S.PlaceholderTitle>
                        {t(`conectados.subcategories.${subcategory.key}.title`)}
                      </S.PlaceholderTitle>
                    </S.SubcategoryPlaceholder>
                  )}
                </S.SubcategoryButton>
              </S.SubcategoryLink>
            ))}
          </S.SubcategoriesGrid>
        </PageTransition>
      </PageContainer>
    </BackgroundWrapper>
  );
}

export default CategoryPage; 